import axios from 'axios'
import http from '../http'
import { IGetSignedUrlParams, IS3ObjectResponse, IS3UploadParams } from './models'

const awsGatewayAPI = http.createClient(`${process.env.NEXT_PUBLIC_GATEWAY_URL}`)

export const getSignedUrl = async (params: IGetSignedUrlParams) => {
	const { data } = await awsGatewayAPI.get<IS3ObjectResponse>('/signed-url', {
		params: {
			env: params.env,
			templateType: params.templateType,
			templateSubtype: params.templateSubtype,
			fileName: params.file.name,
			contentType: params.file.type,
		},
	})
	return data
}

export const uploadBySignedUrl = async (params: IS3UploadParams) => {
	const { data } = await axios.put(params.signedUrl, params.file, {
		headers: {
			'Content-Type': params.file.type,
		},
	})
	return data
}
